import React from 'react'
import LoggedHeader from '../unit/LoggedHeader'
import './vote.css'
import { Link, NavLink } from 'react-router-dom'
import ManageSubject from '../subject/ManageSubject'
import SingleChoice from '../subject/SingleChoice'
import MultiChoice from '../subject/MultiChoice'
import TextSubject from '../subject/TextSubject'

import {CheckedCorMBox, UnCheckedCorMBox} from '../unit/CorMBox'
import ItemCreate from '../item/ItemCreate'

class VoteCreate extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {

        return (
            <div className="vote">
                <LoggedHeader />
                <div className="vote-article">
                    <div className="vote-main">
                        <div className="vote-left">
                            <CheckedCorMBox name="创建投票"></CheckedCorMBox>
                            <div className="vote-left-aline"></div>
                            <Link to="voteManage" className="none-text-decoration">
                                <UnCheckedCorMBox name="管理投票"></UnCheckedCorMBox>
                            </Link>
                        </div>

                        <div className="vote-middle">

                        </div>
                        
                        <div className="vote-right">
                            <ItemCreate name="投票"></ItemCreate>
                            
                            <ManageSubject></ManageSubject>

                            <div className="vote-right-bottom">
                                <SingleChoice id={1}></SingleChoice>
                                <SingleChoice id={2}></SingleChoice>
                                <SingleChoice id={3}></SingleChoice>
                                <MultiChoice id={4}></MultiChoice>
                                <TextSubject id={5}></TextSubject>
                            </div>
                        </div>

                        <Link to="teacherHome">
                            <img className="vote-back" src={require("../assert/back.png")}></img>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default VoteCreate;